module.exports = __webpack_public_path__ + "img/Processing.d556ad86.svg";